import React, { useState, useRef, useEffect, useContext } from "react";
import { isMobile } from "react-device-detect";
import "./style.css";
import { Link, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ListaCarrinho from "../../../../comps/ListaCarrinho";
import MyContext from "../../../../comps/context";
import ItensMenu from "./ItensMenu";
import IputPsq from "./InputPsq";
import IptMobile from "./IptMobile";
import {
  faHeart,
  faShoppingCart,
  faUser,
} from "@fortawesome/free-solid-svg-icons";
import { faMessage } from "@fortawesome/free-solid-svg-icons/faMessage";

export default function MenuInicio(props) {
  const navigateTo = useNavigate();
  const [isCartOpen, setIsCartOpen] = useState(false); // State to control the cart sidebar
  const [texto, setTexto] = useState("");
  const { myVariable } = useContext(MyContext);
  const dropdownSgd = useRef(null); // This seems to be for search suggestions

  // Function to toggle the cart sidebar
  const toggleCart = () => {
    setIsCartOpen(!isCartOpen);
  };

  // Effect to handle clicks outside the cart sidebar to close it
  useEffect(() => {
    const handleClickOutsideCart = (event) => {
      // Assuming you'll have a ref for the cart sidebar itself
      // If the click is outside the cart and the cart is open, close it
      if (
        isCartOpen &&
        document.getElementById("cart-sidebar") &&
        !document.getElementById("cart-sidebar").contains(event.target) &&
        !event.target.closest("#abreLista") // Don't close if the click is on the cart icon itself
      ) {
        setIsCartOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutsideCart);
    return () => {
      document.removeEventListener("mousedown", handleClickOutsideCart);
    };
  }, [isCartOpen]); // Re-run when isCartOpen changes

  // Mobile rendering
  if (isMobile) {
    return (
      <>
        <IptMobile navigateTo={navigateTo} />
      </>
    );
  } else {
    // Desktop rendering
    return (
      <>
        <header className={`header navbar-area`}>
          <div className="header-middle">
            <div className="container">
              <div className="d-flex justify-content-between align-items-center">
                <div className="col-lg-3 col-md-3 col-7">
                  <Link className="navbar-brand" to="/">
                    <span>WeLessa</span>
                  </Link>
                </div>
                <div className="col-lg-6 col-md-7 d-xs-none">
                  <div className="main-menu-search" ref={dropdownSgd}>
                    <IputPsq navigateTo={navigateTo} />
                  </div>
                </div>

                <div className="col-lg-3 col-md-2 col-5">
                  <div className="navbar-cart">
                    <div className="d-flex cart-items gap-3">
                      <div class="button-container">
                        <button className="main-btn">
                          <FontAwesomeIcon icon={faMessage} />
                        </button>
                        <p class="button-text">Atendimento</p>
                      </div>

                      <div class="button-container">
                        <button className="main-btn">
                          <FontAwesomeIcon icon={faUser} />
                        </button>
                        <p class="button-text">Minha Conta</p>
                      </div>

                      <div class="button-container">
                        <button
                          id="abreLista"
                          onClick={toggleCart}
                          className="main-btn"
                        >
                          <FontAwesomeIcon icon={faShoppingCart} />
                          <span id="tic" className="total-items">
                            {myVariable}
                          </span>
                        </button>
                        <p class="button-text">Meu Carrinho</p>
                      </div>

                      {/* Cart Sidebar */}
                      <div
                        id="cart-sidebar"
                        className={`cart-sidebar ${isCartOpen ? "open" : ""}`}
                      >
                        <div className="cart-sidebar-header">
                          <h3>Meu Carrinho</h3>
                          <button onClick={toggleCart} className="close-btn">
                            &times;
                          </button>
                        </div>
                        <div className="cart-sidebar-body"></div>
                      </div>
                      {/* Overlay */}
                      {isCartOpen && (
                        <div
                          className="cart-overlay"
                          onClick={toggleCart}
                        ></div>
                      )}
                    </div>
                  </div>

                  <div className="topNav"></div>
                </div>
              </div>
            </div>
          </div>
          <div className="container">
            <ItensMenu />
          </div>
        </header>
      </>
    );
  }
}
